import { ReactNode } from "react";
import "./EmptyState.css";

type EmptyStateProps = {
  message?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  iconName?: "emoji_events" | "sports_tennis" | "leaderboard";
  action?: ReactNode;
  className?: string;
};

export default function EmptyState({
  message,
  title,
  description,
  icon,
  iconName,
  action,
  className,
}: EmptyStateProps) {
  const classes = ["empty-state", className].filter(Boolean).join(" ");
  const heading = title ?? message;

  return (
    <div className={classes} role="status" aria-live="polite">
      {(icon || iconName) && (
        <span className="empty-state__icon" aria-hidden="true">
          {icon || <span className="material-symbols-outlined">{iconName}</span>}
        </span>
      )}
      {heading && <strong className="empty-state__title">{heading}</strong>}
      {description && <p className="empty-state__description">{description}</p>}
      {action}
    </div>
  );
}
